import React from "react";
import PropTypes from "prop-types";
import TextBlock from "../../components/ui/TextBlock";
import "./SpecTile.scss";
const VARIANTS = {
	imageLeft: "image-left",
	imageRight: "image-right",
};

const SpecTile = ({
	imageSrc,
	imageSrcMobile,
	imageAlt,
	eyebrow,
	title,
	paragraph,
	variant,
	className,
	badges,
}) => {
	const modifier = VARIANTS[variant] || VARIANTS.imageLeft;

	return (
		<section
			className={`spec-tile spec-tile--${modifier} ${className || ""} global-padding`.trim()}>
			<div className="spec-tile__media">
				{imageSrcMobile ? (
					<>
						<img
							src={imageSrc}
							alt={imageAlt}
							className="spec-tile__image spec-tile__image--desktop"
							loading="lazy"
						/>
						<img
							src={imageSrcMobile}
							alt={imageAlt}
							className="spec-tile__image spec-tile__image--mobile"
							loading="lazy"
						/>
					</>
				) : (
					<img
						src={imageSrc}
						alt={imageAlt}
						className="spec-tile__image"
						loading="lazy"
					/>
				)}
			</div>

			<div className="spec-tile__content">
				<TextBlock
					paragraph={eyebrow}
					fontSize={16}
					fontWeight={600}
					color="black"
					align="left"
				/>
				<TextBlock
					paragraph={title}
					// fontSize={32}
					fontWeight={400}
					color="black"
					align="left"
				/>
				<hr />
				<TextBlock
					paragraph={paragraph}
					fontSize={20}
					fontWeight={280}
					color="black"
					align="left"
				/>
				{badges && badges.length > 0 && (
					<ul className="spec-tile__badges">
						{badges.map((label) => (
							<li key={label} className="spec-tile__badge">
								{label}
							</li>
						))}
					</ul>
				)}
			</div>
		</section>
	);
};

SpecTile.propTypes = {
	imageSrc: PropTypes.string.isRequired,
	imageSrcMobile: PropTypes.string,
	imageAlt: PropTypes.string.isRequired,
	eyebrow: PropTypes.string,
	title: PropTypes.string,
	paragraph: PropTypes.string,
	variant: PropTypes.oneOf(["imageLeft", "imageRight"]),
	className: PropTypes.string,
	badges: PropTypes.arrayOf(PropTypes.string),
};

SpecTile.defaultProps = {
	eyebrow: "",
	title: "",
	paragraph: "",
	variant: "imageLeft",
	className: "",
	imageSrcMobile: null,
	badges: null,
};

export default SpecTile;
